export default "__VITE_ASSET__Dc5XKuvb__"